import { Metronome as AvTimer } from '@tunasong/icons'
import type { Rhythm } from '@tunasong/models'
import type { FC } from 'react'
import { useMetronome } from './metronome.hook.js'
import { IconButton, type IconButtonProps } from '@tunasong/ui-lib'

export interface MetronomeProps extends IconButtonProps {
  rhythm: Rhythm
  flashBackground?: boolean
}

export const MetronomeButton: FC<MetronomeProps> = props => {
  const { rhythm, flashBackground, ...restProps } = props

  const { toggle, playing, tik } = useMetronome(rhythm)
  /** We need to change the color of an element in order to trigger rendering */
  const buttonColor = playing
    ? tik
      ? 'var(--tuna-palette-primary-main)'
      : 'var(--tuna-palette-secondary-main)'
    : 'var(--tuna-palette-primary-main)'

  const backgroundColor = playing
    ? tik
      ? 'var(--tuna-palette-primary-light)'
      : 'var(--tuna-palette-secondary-light)'
    : 'var(--tuna-palette-background-default)'

  return (
    <>
      {flashBackground ? (
        <style>{`body { background-color: ${backgroundColor} !important; transition: background 0.05s ease-out; }`}</style>
      ) : null}
      <IconButton {...restProps} onClick={toggle} style={{ color: buttonColor, padding: 0 }}>
        <AvTimer />
      </IconButton>
    </>
  )
}

export default MetronomeButton
